module.exports = __webpack_public_path__ + "static/img/product_category.eabd02c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/product_category.png
// module id = lxpW
// module chunks = 1